var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoCoinsCovered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 115,
    viewBox: "0 0 114 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 114,
    height: 115,
    rx: 25,
    fill: "url(#paint0_linear_344_152)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 94,
    height: 95,
    rx: 20,
    fill: "url(#paint1_linear_344_152)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 74.6666C66.2047 74.6666 73.6666 67.2047 73.6666 57.9999C73.6666 48.7952 66.2047 41.3333 57 41.3333C47.7952 41.3333 40.3333 48.7952 40.3333 57.9999C40.3333 67.2047 47.7952 74.6666 57 74.6666Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 58H73.6666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41.3333C61.1688 45.8972 63.5379 51.82 63.6666 57.9999C63.5379 64.1799 61.1688 70.1027 57 74.6666C52.8312 70.1027 50.4621 64.1799 50.3333 57.9999C50.4621 51.82 52.8312 45.8972 57 41.3333Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_152",
    x1: 8.48936,
    y1: 5.44737,
    x2: 104.108,
    y2: 108.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BD79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_152",
    x1: 17,
    y1: 14.5,
    x2: 96,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BD7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCoinsCovered);
export default __webpack_public_path__ + "static/media/CryptoCoinsCovered.9edcca53bcd87b670ec3f0b924672cf4.svg";
export { ForwardRef as ReactComponent };